import React, { useState, useEffect } from "react";
import { FaTelegramPlane, FaTwitter, FaInstagram } from "react-icons/fa"; // Updated for Telegram Icon
import "./Header.css";

const Header = () => {
  const [currentDate, setCurrentDate] = useState("");
  

  // Update the current date
  useEffect(() => {
    const now = new Date();
    const options = { weekday: "long", month: "long", day: "numeric" };
    const formattedDate = now.toLocaleDateString("fa-IR", options);
  
    // Extract date components
    const parts = formattedDate.split(" ");
    if (parts.length >= 4) {
      // Reformat the date: weekday، day month ، year
      const customFormattedDate = `${parts[0]}، ${parts[2]} ${parts[1]} ، ${parts[3]}`;
      setCurrentDate(customFormattedDate);
    } else {
      setCurrentDate(formattedDate);
    }
  }, []);
  
  const scrollToFooter = () => {
    const footerElement = document.getElementById("footer");
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  

  return (
    <header className="header">
      <div className="container-header">
        {/* Right Side: Date and Social Media Icons */}
        <div className="nav-left">
          <div className="date">{currentDate}</div>
          <div className="social-icons">
            <a href="https://t.me/khanehyeghtesad" target="_blank" rel="noopener noreferrer">
              <FaTelegramPlane />
            </a>
            <a href="https://x.com/khanehyeghtesad" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://instagram.com/khanehyeghtesad" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Left Side: Categories and Links */}
        <div className="nav-right">
          <ul className="nav-links">
            <li>
              <a >دسته‌بندی‌ها</a>
              <ul className="dropdown">
                <li>اقتصاد ایران</li>
                <li>بورس</li>
                <li>بانک، بیمه و بورس</li>
                <li>صنعت</li>
                <li>کشاورزی</li>
                <li>راه و ساختمان</li>
                <li>انرژی</li>
              </ul>
            </li>
            <li>
            <a onClick={scrollToFooter} style={{ cursor: "pointer" }}>
                درباره ما
              </a>
              </li>
            {/* <li>
              <a href="/contact">تماس با ما</a>
            </li> */}
          </ul>
        </div>

        {/* Hamburger Menu */}
        <div className="hamburger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
